"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getAdminSidebarBanner,
  getSidebarBanner,
  setAdminSidebarBanner,
} from "@/lib/banner/api";
import { queryKeys } from "@/lib/query-keys";
import { MissingSupabaseConfigError } from "@/lib/supabase/env";

function retryUnlessMissingConfig(failureCount: number, error: unknown) {
  return error instanceof MissingSupabaseConfigError ? false : failureCount < 1;
}

export function useSidebarBanner(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.sidebarBanner,
    queryFn: getSidebarBanner,
    enabled,
    retry: retryUnlessMissingConfig,
    staleTime: 60_000,
  });
}

export function useAdminSidebarBanner(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.adminSidebarBanner,
    queryFn: getAdminSidebarBanner,
    enabled,
    retry: retryUnlessMissingConfig,
  });
}

export function useSetAdminSidebarBanner() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setAdminSidebarBanner,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.sidebarBanner }),
        queryClient.invalidateQueries({ queryKey: queryKeys.adminSidebarBanner }),
      ]);
    },
  });
}
